<template>
  <div class="wrapper-campo-form">
    <div v-if="!item.blocoPadrao" class="campo-form-header columns">
      <div class="column campo-form-nome" :class="{'has-error': !isTituloValido}">
        <TrfToolbarTextEditorInline
          class="column py-0"
          :id="tituloId"
          :is-obrigatorio="true"
          :defaultText="item.tituloHtml? item.tituloHtml : `<p>Pergunta</p>`"
          @changeText="setTitulo"
          @ready="preselecionarTitulo"
          tag="p"
          :editorStyle="`p.mce-content-body { width: 100%; background-color:#EEEEEE66; font-size: 1rem!important; color: #333!important; padding: .25rem .75rem; border-bottom: 1px solid #333333; transition: border 0.35s ease-in-out 0s} p.mce-content-body:focus-visible, p.mce-content-body:hover { outline: 0 none; border-bottom: 1px solid ${this.estilosPadrao.CorPrimaria}FF}`"
          ref="campoTitulo"
          :custom-toolbar="true"
          :toolbar-persist="true"
          :maxlength="500"
        ></TrfToolbarTextEditorInline>
      </div>
      <div class="column campo-form-tipo multiselect-econtador">
        <Multiselect
          v-model="formData.tipoInput"
          placeholder="Selecione o campo"
          :options="opcoesValidas"
          :canDeselect="false"
          :canClear="false"
          @change="(value, select$) => tipoModificado(value, select$)"
        >
          <template v-slot:singlelabel="{ value }">
            <div class="multiselect-single-label"><i :class="`mdi ${value.icon} mdi-14px mr-3`" aria-hidden="true"></i> {{ value.nome }}</div>
          </template>

          <template v-slot:option="{ option }"><i :class="`mdi ${option.icon} mdi-14px mr-3`" aria-hidden="true"></i> {{ option.nome }} </template>
        </Multiselect>
      </div>
    </div>
    <slot name="input-type">
      <div v-if="tipoInput" class="campo-form-content">
        <component
          :is="tipoInput?.getComponenteEdicao()"
          :hasOptions="hasOpcoes"
          :pHasOpcaoOutro="formData.hasOpcaoOutro"
          :pOpcoes="formData.opcoes"
          @update:opcoes="setOpcoes"
        />
      </div>
    </slot>
    <hr />
    <div class="column campo-form-footer columns is-justify-content-flex-end">
      <div v-if="!item.blocoPadrao" class="column is-narrow">
        <a class="button is-white" @click="removerCampo">
          <i :class="`mdi mdi-trash-can-outline is-size-5`" aria-hidden="true"></i>
        </a>
      </div>
      <div v-if="!item.blocoPadrao" class="column is-narrow">
        <hr class="vertical-hr"/>
      </div>
      <div class="column is-narrow">
        <TrfSwitcher pLabel="Obrigatória" :pInitialValue="item.obrigatorio" @update:value="setObrigatorio"/>
      </div>
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { tipoInputEnum, tipoInputPadraoEnum } from './enum/TipoInput.enum';
import { stylesUtils } from '../../util/styles.utils';
import TrfToolbarTextEditorInline from '../../components/ToolbarTextEditor/inline.vue' // import comum para evitar condição de corrida no foco automatico
import CampoPersonalizado from './models/campoPersonalizado.model';
import { gerarGUID } from '../../util/uuid.utils';

export default {
  name: 'TrfCampoForm',
  emits: ['delete:campo', 'update:form-data'],
  components: {
    TrfToolbarTextEditorInline,
    Multiselect: defineAsyncComponent(() => import('@vueform/multiselect')),
    TrfCampoParagrafo: defineAsyncComponent(() => import('./components/InputParagrafo.vue')),
    TrfCampoMultiplaEscolha: defineAsyncComponent(() => import('./components/InputMultiplaEscolha.vue')),
    TrfCaixaDeSelecao: defineAsyncComponent(() => import('./components/InputCaixaDeSelecao.vue')),
    TrfListaSuspensa: defineAsyncComponent(() => import('./components/InputListaSuspensa.vue')),
    TrfBlocoNomeFantasia: defineAsyncComponent(() => import('./components/BlockNomeFantasia.vue')),
    TrfBlocoNomeEmpresarial: defineAsyncComponent(() => import('./components/BlockNomeEmpresarial.vue')),
    TrfBlocoEnderecoEmpresarial: defineAsyncComponent(() => import('./components/BlockEnderecoEmpresarial.vue')),
    TrfBlocoDadosComplementares: defineAsyncComponent(() => import('./components/BlockDadosComplementares.vue')),
    TrfBlocoSocios: defineAsyncComponent(() => import('./components/BlockSocios.vue')),
    TrfBlocoSocioDados: defineAsyncComponent(() => import('./components/BlockSocioDados.vue')),
    TrfBlocoSocioDadosComplementares: defineAsyncComponent(() => import('./components/BlockSocioDadosComplementares.vue')),
    TrfBlocoIptuEmpresarial: defineAsyncComponent(() => import('./components/BlockIptuEmpresarial.vue')),
    TrfBlocoSocioTipo: defineAsyncComponent(() => import('./components/BlockSocioTipo.vue')),
    TrfBlocoEnderecoSocio: defineAsyncComponent(() => import('./components/BlockEnderecoSocio.vue')),
    TrfBlocoSocioContato: defineAsyncComponent(() => import('./components/BlockSocioContato.vue')),
    TrfBlocoAnexos: defineAsyncComponent(() => import('./components/BlockAnexos.vue')),
    TrfSwitcher: defineAsyncComponent(() => import('../Checkbox/switcher.vue'))
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    order: {
      type: Number,
      default: null
    },
    pOpcoes: {
      type: Array,
      default: null
    }
  },
  data() {
    const defaultFormData = new CampoPersonalizado();
    defaultFormData.updateDados(this.item);
    return {
      tituloId: gerarGUID(),
      estilosPadrao: '',
      preselecionarTituloNoReady: false,
      opcoes: [
        { value: 'TEXT', nome: tipoInputEnum.TEXT.getNome(), icon: tipoInputEnum.TEXT.getIcone() },
        { value: 'RADIO', nome: tipoInputEnum.RADIO.getNome(), icon: tipoInputEnum.RADIO.getIcone() },
        { value: 'CHECKBOX', nome: tipoInputEnum.CHECKBOX.getNome(), icon: tipoInputEnum.CHECKBOX.getIcone() },
        { value: 'SELECT', nome: tipoInputEnum.SELECT.getNome(), icon: tipoInputEnum.SELECT.getIcone() },
      ],
      formData: defaultFormData
    };
  },
  computed: {
    tipoInput() {
      if (!this.item.blocoPadrao && !this.formData.tipoInput) return null;
      let tipoInput = null;
      if (this.item.blocoPadrao) {
        tipoInput = tipoInputPadraoEnum.getByKey(this.item.tipoInput);
      } else {
        tipoInput = tipoInputEnum.getByKey(this.formData.tipoInput);
      }
      return tipoInput;
    },
    opcoesValidas() {
      if (!Array.isArray(this.pOpcoes) || this.pOpcoes.length == 0) return this.opcoes;

      const opcoesValidas = this.opcoes.filter(opcao => {
        return this.pOpcoes.includes(opcao.value)
      })

      this.pOpcoes.forEach(opcao => {
        if (opcao) {
          opcoesValidas.push(opcao);
        }
      })

      return opcoesValidas
    },
    isTituloValido() {
      return !!this.formData.titulo && !!this.formData.tituloHtml
    },
    hasOpcoes() {
      return Array.isArray(this.formData.opcoes) && this.formData.opcoes.length > 0
    }
  },
  watch: {
    formData: {
      immediate: true,
      deep: true,
      handler() {
        this.$emit('update:form-data', this.formData)
      }
    }
  },
  methods: {
    setTitulo(tituloHtml, field) {
      this.formData.updateDados({tituloHtml: tituloHtml? tituloHtml : ''}); // Garante tipagem
      this.formData.updateDados({titulo: field.getValueAsText()? field.getValueAsText() : ''});
    },
    setObrigatorio(value) {
      this.formData.updateDados({obrigatorio: value});
    },
    setOpcoes(opcoes, hasOpcaoOutro) {
      this.formData.updateDados({opcoes: opcoes, hasOpcaoOutro: hasOpcaoOutro});
    },
    clearOpcoes() {
      this.formData.updateDados({opcoes: []});
    },
    getFormData() {
      return this.formData
    },
    tipoModificado(value, select) {
      this.formData.updateDados({tipoInput: value, hasOpcaoOutro: false});
      this.clearOpcoes();
    },
    removerCampo() {
      this.$emit('delete:campo', this.item)
    },
    setSelecionaTituloNoReady() {
      this.preselecionarTituloNoReady = true
    },
    async preselecionarTitulo() {
      if (!this.preselecionarTituloNoReady) return;

      await this.$nextTick();
      if (!this.$refs.campoTitulo) return;
      await this.$refs.campoTitulo.focusAndSelect();
    }
  },
  mounted() {
    this.estilosPadrao = stylesUtils.adquirirEstilosCookie();
  }
};
</script>
<style lang="scss" scoped>
@import '../../assets/sass/variables.scss';
.vertical-hr {
  border-top: 0 none;
  border-left: 2px solid #EEE;
  height: 100%;
  margin: 0;
}
</style>
<style lang="scss">
  .wrapper-campo-form .campo-form-nome.has-error > .editor-wrapper .mce-content-body {
    border-bottom-color: #a94442FF!important;
  }
</style>